/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityServiceAreaStatus } from './FacilityServiceAreaStatus';
import {
    FacilityServiceAreaStatusFromJSON,
    FacilityServiceAreaStatusFromJSONTyped,
    FacilityServiceAreaStatusToJSON,
    FacilityServiceAreaStatusToJSONTyped,
} from './FacilityServiceAreaStatus';

/**
 * 
 * @export
 * @interface BulkUpdateFacilityServiceAreasRequest
 */
export interface BulkUpdateFacilityServiceAreasRequest {
    /**
     * 
     */
    ids: Array<string>;
    /**
     * 
     */
    status?: FacilityServiceAreaStatus;
    /**
     * 
     */
    notes?: string;
}



/**
 * Check if a given object implements the BulkUpdateFacilityServiceAreasRequest interface.
 */
export function instanceOfBulkUpdateFacilityServiceAreasRequest(value: object): value is BulkUpdateFacilityServiceAreasRequest {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function BulkUpdateFacilityServiceAreasRequestFromJSON(json: any): BulkUpdateFacilityServiceAreasRequest {
    return BulkUpdateFacilityServiceAreasRequestFromJSONTyped(json, false);
}

export function BulkUpdateFacilityServiceAreasRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateFacilityServiceAreasRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'status': json['status'] == null ? undefined : FacilityServiceAreaStatusFromJSON(json['status']),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function BulkUpdateFacilityServiceAreasRequestToJSON(json: any): BulkUpdateFacilityServiceAreasRequest {
    return BulkUpdateFacilityServiceAreasRequestToJSONTyped(json, false);
}

export function BulkUpdateFacilityServiceAreasRequestToJSONTyped(value?: BulkUpdateFacilityServiceAreasRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
        'status': FacilityServiceAreaStatusToJSON(value['status']),
        'notes': value['notes'],
    };
}

